<template>
  <div>
    <el-breadcrumb class="breadcrumb" separator=">">
      <el-breadcrumb-item v-for="item in BreadArr" :key="item.menuKey">{{
        item.title
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import store from "@/store";
import { ref, watch, watchEffect, inject, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
// import { menuObj } from '@/router/allRoutes.js';
export default {
  props: ["breadList"],
  setup() {
    let BreadTilte = ref(inject("BreadTilte"));

    let route = useRoute();
    const breadcrumbItems = ref([]);

    // let breadList = ref(props.breadList)
    let breadList = ref(route.matched);

    let result = ref();
    let resultPar = ref();
    const pageTitle = ref("");

    const BreadArr = computed(() => {
      let menuKey = route.meta.menuKey;
      console.log(menuKey, "menuKey");
      console.log(store.state.router2menu, "menuKey2");
      console.log(route, "menuKey3");
      // fullPath:"/EntrustManage/list?isPlanCar=1"
      let arr = [];
      let _parentKey = "";
      let { parentKey, data } = store.state.router2menu[menuKey];
      _parentKey = parentKey;
      data.title = data.menuName;
      arr.push(data);
      while (_parentKey) {
        let { parentKey, data } = store.state.router2menu[_parentKey];
        _parentKey = parentKey;
        data.title = data.menuName;
        arr.push(data);
      }
      let fullPath = route.fullPath;
      if (fullPath.indexOf("?") > -1){
        let query = fullPath.split("?")[1];
        if ( query.includes("isPlanCar=1")){
          arr[2].title = "期车管理";
          arr[1].title = "期车管理";
        }
        if ( query.includes("isPlanCar=0")){
          arr[2].title = "明拍管理";
          arr[1].title = "明拍管理";
        }
      }

      return arr.reverse();
    });

    // watchEffect(
    //   () => {
    //     // 新值 传递来的数据
    //     // console.log('新值 传递来的数据',BreadTilte.value);
    //     BreadTilte.value = BreadTilte.value;
    //   },
    //   { deep: true, immediate: true }
    // );

    // watch(
    //   route,
    //   () => {
    //     console.log(route, "route");
    //     let currentPath = route.path;
    //     let routeList = route.matched[0].children;
    //     pageTitle.value = route.meta.title;
    //     // console.log('watch新值 传递来的数据',BreadTilte.value);
    //     routeList.find((item) => {
    //       console.log(item, "item");

    //       if (item.path === currentPath) {
    //         result.value = item;
    //       }
    //     });
    //   },
    //   { immediate: true }
    // );
    return {
      BreadTilte,
      resultPar,
      result,
      breadcrumbItems,
      // menuObj,
      breadList,
      pageTitle,
      route,
      BreadArr,
    };
  },
  mounted() {},
};
</script>

<style lang="scss">
.router-link-active {
  text-decoration: none;
  // color: #993333;
  color: #4d4d4d;
}

.title_link {
  width: 4px;
  background: #848db9;
  height: 18px;
  margin-right: 10px;
}

a {
  text-decoration: none;
  color: rgb(36, 36, 36);
}

.el-breadcrumb {
  display: block;
  line-height: 50px;
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

​ .breadcrumb-enter-from,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

​ .breadcrumb-leave-active {
  position: absolute;
}

.breadcrumb {
  display: flex;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;
  align-items: center;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
